import {
  SET_CIDS,
  SET_CID
} from './mutationTypes'

export const mutations = {
  [SET_CIDS]: (state, payload) => state.cids = payload,
  [SET_CID]: (state, payload) => state.cid = payload
}
